// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Uuid from "uuid";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as CountryCode from "../../primitives/CountryCode.res.js";
import * as StackFields from "../../resources/layout-and-structure/StackFields.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as AddressComboBoxField from "../AddressComboBoxField.res.js";
function countryLabel(country) {
  let match = CountryCode.parseIso3166Alpha2(country);
  if (typeof match === "object") {
    return I18n.t("France");
  }
  switch (match) {
    case "FR":
      return I18n.t("France");
    case "BE":
      return I18n.t("Belgium");
    case "LU":
      return I18n.t("Luxembourg");
  }
}
function makeAddress(countryOpt, isDefaultOpt) {
  let country = countryOpt !== undefined ? countryOpt : "";
  let isDefault = isDefaultOpt !== undefined ? isDefaultOpt : true;
  return {
    key: Uuid.v4(),
    label: "",
    recipient: "",
    street: "",
    postalCode: "",
    city: "",
    country: countryLabel(country),
    isBilling: isDefault,
    isDelivery: isDefault
  };
}
function defaults(param) {
  return Stdlib_Array.filterMap([param.isBilling ? "BILLING" : undefined, param.isDelivery ? "DELIVERY" : undefined], value => value);
}
function withExclusiveBilling(addresses, committedAddress) {
  if (committedAddress.isBilling) {
    return addresses.map(address => {
      if (address.key === committedAddress.key) {
        return address;
      }
      let newrecord = {
        ...address
      };
      newrecord.isBilling = false;
      return newrecord;
    });
  } else {
    return addresses;
  }
}
function get(values, field) {
  switch (field) {
    case "Label":
      return values.label;
    case "Recipient":
      return values.recipient;
    case "Street":
      return values.street;
    case "PostalCode":
      return values.postalCode;
    case "City":
      return values.city;
    case "Country":
      return values.country;
    case "IsBilling":
      return values.isBilling;
    case "IsDelivery":
      return values.isDelivery;
  }
}
function set(values, field, value) {
  switch (field) {
    case "Label":
      return {
        label: value,
        recipient: values.recipient,
        street: values.street,
        postalCode: values.postalCode,
        city: values.city,
        country: values.country,
        isBilling: values.isBilling,
        isDelivery: values.isDelivery
      };
    case "Recipient":
      return {
        label: values.label,
        recipient: value,
        street: values.street,
        postalCode: values.postalCode,
        city: values.city,
        country: values.country,
        isBilling: values.isBilling,
        isDelivery: values.isDelivery
      };
    case "Street":
      return {
        label: values.label,
        recipient: values.recipient,
        street: value,
        postalCode: values.postalCode,
        city: values.city,
        country: values.country,
        isBilling: values.isBilling,
        isDelivery: values.isDelivery
      };
    case "PostalCode":
      return {
        label: values.label,
        recipient: values.recipient,
        street: values.street,
        postalCode: value,
        city: values.city,
        country: values.country,
        isBilling: values.isBilling,
        isDelivery: values.isDelivery
      };
    case "City":
      return {
        label: values.label,
        recipient: values.recipient,
        street: values.street,
        postalCode: values.postalCode,
        city: value,
        country: values.country,
        isBilling: values.isBilling,
        isDelivery: values.isDelivery
      };
    case "Country":
      return {
        label: values.label,
        recipient: values.recipient,
        street: values.street,
        postalCode: values.postalCode,
        city: values.city,
        country: value,
        isBilling: values.isBilling,
        isDelivery: values.isDelivery
      };
    case "IsBilling":
      return {
        label: values.label,
        recipient: values.recipient,
        street: values.street,
        postalCode: values.postalCode,
        city: values.city,
        country: values.country,
        isBilling: value,
        isDelivery: values.isDelivery
      };
    case "IsDelivery":
      return {
        label: values.label,
        recipient: values.recipient,
        street: values.street,
        postalCode: values.postalCode,
        city: values.city,
        country: values.country,
        isBilling: values.isBilling,
        isDelivery: value
      };
  }
}
let Lenses = {
  get: get,
  set: set
};
let CustomerAddressFormLenses = {
  Lenses: Lenses,
  get: get,
  set: set
};
let CustomerAddressForm = Form.Make({
  get: get,
  set: set
});
let customerAddressFormSchema = [{
  TAG: "StringNotEmpty",
  _0: "Label"
}];
let styles = {
  container: {
    "boxSizing-kB7OPa": "boxSizing-x9f619",
    "borderColor-kVAM5u": "borderColor-x1t4mavk",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "padding-kmVPX3": "padding-xs0fqhl",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/modules/Customer/CustomerAddressEditModal.res.js:212"
  }
};
function CustomerAddressEditModal$DefaultToggleTile(props) {
  let match = {
    className: "boxSizing-x9f619 borderColor-x1t4mavk borderRadius-x1sxf85j borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 display-x78zum5 padding-xs0fqhl width-xh8yej3",
    "data-style-src": "wino-gc:src/modules/Customer/CustomerAddressEditModal.res.js:212"
  };
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: match.className,
    style: match.style
  });
}
let DefaultToggleTile = {
  styles: styles,
  make: CustomerAddressEditModal$DefaultToggleTile
};
function CustomerAddressEditModal$CustomerAddressEditor(props) {
  let onRequestRemove = props.onRequestRemove;
  let onRequestClose = props.onRequestClose;
  let onCommit = props.onCommit;
  let errorMessage = props.errorMessage;
  let recipientPlaceholder = props.recipientPlaceholder;
  let isNew = props.isNew;
  let value = props.value;
  let captureEvent = SessionTracker.useCaptureEvent();
  let initialValues_label = value.label;
  let initialValues_recipient = value.recipient;
  let initialValues_street = value.street;
  let initialValues_postalCode = value.postalCode;
  let initialValues_city = value.city;
  let initialValues_country = value.country;
  let initialValues_isBilling = value.isBilling;
  let initialValues_isDelivery = value.isDelivery;
  let initialValues = {
    label: initialValues_label,
    recipient: initialValues_recipient,
    street: initialValues_street,
    postalCode: initialValues_postalCode,
    city: initialValues_city,
    country: initialValues_country,
    isBilling: initialValues_isBilling,
    isDelivery: initialValues_isDelivery
  };
  let match = CustomerAddressForm.useFormPropState({
    initialValues: initialValues,
    schema: customerAddressFormSchema,
    onSubmitSuccess: param => onRequestClose()
  });
  let formDispatch = match[1];
  let formState = match[0];
  let onSubmit = (param, values) => {
    if (!isNew) {
      captureEvent("customer_address_quickedit_click_save");
    }
    let newrecord = {
      ...value
    };
    return Future.mapOk(onCommit((newrecord.isDelivery = values.isDelivery, newrecord.isBilling = values.isBilling, newrecord.country = values.country.trim(), newrecord.city = values.city.trim(), newrecord.postalCode = values.postalCode.trim(), newrecord.street = values.street.trim(), newrecord.recipient = values.recipient.trim(), newrecord.label = values.label.trim(), newrecord)), undefined, param => {});
  };
  let onChangeAddress = value => formDispatch({
    TAG: "FieldValueChanged",
    _0: "Street",
    _1: param => value
  });
  let onRequestAutoComplete = address => {
    if (address.label !== "") {
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "Street",
        _1: param => address.name
      });
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "PostalCode",
        _1: param => address.postcode
      });
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "City",
        _1: param => address.city
      });
      return formDispatch({
        TAG: "FieldValueChanged",
        _0: "Country",
        _1: param => address.country
      });
    }
  };
  let match$1 = formState.values.recipient.trim();
  let tmp = match$1 === "" && recipientPlaceholder !== undefined ? {
    text: I18n.t("customer_addresses_field.editor.use_recipient_placeholder_action"),
    handler: {
      TAG: "Callback",
      _0: () => formDispatch({
        TAG: "FieldValueChanged",
        _0: "Recipient",
        _1: param => recipientPlaceholder
      })
    }
  } : undefined;
  let match$2 = CountryCode.parseIso3166Alpha2(formState.values.country);
  let tmp$1;
  let exit = 0;
  if (typeof match$2 !== "object" && match$2 === "FR") {
    tmp$1 = JsxRuntime.jsx(AddressComboBoxField.make, {
      addressName: formState.values.street,
      onInputChange: onChangeAddress,
      onRequestAutoComplete: onRequestAutoComplete
    });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(CustomerAddressForm.InputText.make, {
      field: "Street",
      label: I18n.t("Address"),
      placeholder: I18n.t("Address"),
      hideRequired: true
    });
  }
  return JsxRuntime.jsxs(CustomerAddressForm.Core.Provider.make, {
    children: [JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(StackFields.make, {
        children: [errorMessage !== undefined ? JsxRuntime.jsx(NextBanner.make, {
          children: JsxRuntime.jsx(NextBanner.Text.make, {
            text: errorMessage
          }),
          variation: "danger"
        }) : null, JsxRuntime.jsx(CustomerAddressForm.InputText.make, {
          field: "Label",
          label: I18n.t("Title"),
          placeholder: I18n.t("Invoicing")
        }), JsxRuntime.jsx(CustomerAddressForm.InputText.make, {
          field: "Recipient",
          label: I18n.t("Recipient"),
          placeholder: Stdlib_Option.getOr(recipientPlaceholder, I18n.t("Recipient")),
          fieldAction: tmp,
          hideRequired: true
        }), tmp$1, JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(CustomerAddressForm.InputText.make, {
            field: "PostalCode",
            label: I18n.t("Postal code"),
            placeholder: I18n.t("Postal code"),
            hideRequired: true
          }), JsxRuntime.jsx(CustomerAddressForm.InputText.make, {
            field: "City",
            label: I18n.t("City"),
            placeholder: I18n.t("City"),
            hideRequired: true
          })]
        }), JsxRuntime.jsx(CustomerAddressForm.InputCountrySelect.make, {
          field: "Country"
        }), JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(CustomerAddressEditModal$DefaultToggleTile, {
            children: JsxRuntime.jsx(CustomerAddressForm.InputToggleSwitch.make, {
              label: I18n.t("customer_addresses_field.editor.billing_toggle_label"),
              field: "IsBilling",
              hideRequired: true
            })
          }), JsxRuntime.jsx(CustomerAddressEditModal$DefaultToggleTile, {
            children: JsxRuntime.jsx(CustomerAddressForm.InputToggleSwitch.make, {
              label: I18n.t("customer_addresses_field.editor.delivery_toggle_label"),
              field: "IsDelivery",
              hideRequired: true
            })
          })]
        }), props.hasOtherBillingAddress && formState.values.isBilling ? JsxRuntime.jsx(NextBanner.make, {
          children: JsxRuntime.jsx(NextBanner.Text.make, {
            text: I18n.t("customer_addresses_field.editor.billing_replacement_warning")
          }),
          variation: "warning"
        }) : null]
      }),
      spaceX: "xlarge",
      spaceTop: "xlarge"
    }), JsxRuntime.jsxs(Box.make, {
      children: [JsxRuntime.jsx(CanarySeparator.make, {
        orientation: "horizontal"
      }), JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [onRequestRemove !== undefined ? JsxRuntime.jsx(Button.make, {
            variant: "subtle",
            tone: "danger",
            icon: "delete",
            tooltipText: I18n.t("Remove"),
            onPress: () => onRequestRemove()
          }) : null, JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(Button.make, {
              label: I18n.t("Cancel"),
              onPress: () => onRequestClose()
            }), JsxRuntime.jsx(CustomerAddressForm.SubmitButton.make, {
              label: isNew ? I18n.t("customer_addresses_field.editor.add_submit_button_label") : I18n.t("customer_addresses_field.editor.edit_submit_button_label"),
              tone: "success",
              onSubmit: onSubmit
            })],
            space: "normal"
          })],
          align: Stdlib_Option.isSome(onRequestRemove) ? "spaceBetween" : "end"
        }),
        spaceX: "xlarge",
        spaceY: "xlarge"
      })],
      spaceTop: "xlarge"
    })],
    propState: [formState, formDispatch]
  });
}
let CustomerAddressEditor = {
  make: CustomerAddressEditModal$CustomerAddressEditor
};
function CustomerAddressEditModal(props) {
  let __hasOtherBillingAddress = props.hasOtherBillingAddress;
  let __isNew = props.isNew;
  let value = props.value;
  let isNew = __isNew !== undefined ? __isNew : false;
  let hasOtherBillingAddress = __hasOtherBillingAddress !== undefined ? __hasOtherBillingAddress : false;
  return JsxRuntime.jsx(Modal.make, {
    children: value !== undefined ? JsxRuntime.jsx(CustomerAddressEditModal$CustomerAddressEditor, {
      value: value,
      isNew: isNew,
      hasOtherBillingAddress: hasOtherBillingAddress,
      recipientPlaceholder: props.recipientPlaceholder,
      errorMessage: props.errorMessage,
      onCommit: props.onCommit,
      onRequestClose: props.onRequestClose,
      onRequestRemove: props.onRequestRemove
    }, value.key) : null,
    opened: Stdlib_Option.isSome(value),
    title: isNew ? I18n.t("customer_addresses_field.editor.new_modal_title") : I18n.t("customer_addresses_field.editor.edit_modal_title"),
    hideFooter: true
  });
}
let make = CustomerAddressEditModal;
export { countryLabel, makeAddress, defaults, withExclusiveBilling, CustomerAddressFormLenses, CustomerAddressForm, customerAddressFormSchema, DefaultToggleTile, CustomerAddressEditor, make };
/* CustomerAddressForm Not a pure module */